export const PERMISSION_INTERFACES: any = [
  {
    name: 'OU',
    arabic: 'الوحدات التنظ يمية',
    ouRequired: true,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
    children: [
      {
        name: 'OU_LOCATION',
        arabic: 'موقع الوحدات التنظيمية',
        ouRequired: false,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
      {
        name: 'OU_CATEGORY',
        arabic: 'فئة الوحدات التنظيمية',
        ouRequired: false,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
      {
        name: 'OU_TYPE',
        arabic: 'نوع الوحدات التنظيمية',
        ouRequired: false,
        tagRequired: true,
        tagAlias: 'ou_type_tag',
        tag: null,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
    ],
  },
  {
    name: 'DATA_BULK',
    arabic: 'التحميل المجمع',
    ouRequired: false,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'SIGN_SERVICE',
    arabic: ' اعتماد التحديث',
    ouRequired: false,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'ACCOUNCEMENTS',
    arabic: 'الإعلانات',
    ouRequired: false,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'MYSTERY_SHOPPER',
    arabic: 'المتسوق الخفي',
    ouRequired: false,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
    children: [
      {
        name: 'MYSTERY_SHOPPER_TAGS',
        arabic: 'المتسوق الخفي علامات ',
        ouRequired: false,
        tagRequired: true,
        tagAlias: 'mystery_shopper_tag',
        tag: null,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      }
    ],
  },

  {
    name: 'SIGN_SERVICE_DURATION',
    arabic: 'صلاحية الاعتماد',
    ouRequired: false,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'VIEW_SIGN',
    arabic: 'عرض التوقيع',
    ouRequired: false,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
      },
    },
  },

  {
    name: 'ADMIN_PERMISSION',
    arabic: 'إعدادات الصفحة الخارجية',
    ouRequired: false,
    ou: null,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'PRINT_SERVICE',
    arabic: 'إنشاء دليل الخدمات',
    ouRequired: false,
    ou: null,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'BULK_EDIT',
    arabic: 'تحرير التحميل المجمع',
    ouRequired: true,
    ou: null,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },
  {
    name: 'COMMENTS',
    arabic: 'التعليقات',
    ouRequired: true,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        update: false,
        delete: false,
      },
    },
  },

  {
    name: 'VIEW_NOTIFICATIONS',
    arabic: 'عرض كل الإشعارات',
    ouRequired: false,
    ou: null,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'DATA',
    arabic: 'البيانات',
    ouRequired: false,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false
      },
    },
    children: [
      {
        name: 'DATA_TYPE',
        arabic: 'نوع البيانات',
        ouRequired: false,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
      {
        name: 'DATA_TEMPLATE',
        arabic: 'قالب البيانات',
        ouRequired: false,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
      {
        name: 'DATA_FIELD',
        arabic: 'حقل البيانات',
        ouRequired: false,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
      {
        name: 'DATA_FIELD_TYPE',
        arabic: 'نوع حقل البيانات',
        ouRequired: false,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
    ],
  },
  {
    name: 'USER_MANAGEMENT',
    arabic: 'إدارة المستخدم',
    ouRequired: false,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
    children: [
      {
        name: 'ROLE_MANAGEMENT',
        arabic: 'إدارة الأدوار',
        //Create a default role for new signup user, also remove delete button from that role
        ouRequired: false,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
      {
        name: 'PERMISSION_MANAGEMENT',
        arabic: 'إدارة الصلاحيات',
        ouRequired: false,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
    ],
  },
  {
    name: 'KNOWLEDGE_LIBRARY',
    arabic: 'مكتبة المعرفة',
    ouRequired: true,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
    children: [
      {
        name: 'KNOWLEDGE_LIBRARY_CATEGORY',
        arabic: 'تصنيف مكتبة المعرفة',
        ouRequired: false,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
      {
        name: 'KNOWLEDGE_LIBRARY_APPROVAL',
        arabic: 'طلبات مكتبة المعرفة',
        ouRequired: false,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
    ],
  },
  {
    //DONE
    name: 'CONTENT_UPDATE_LOGS',
    arabic: 'سجلات تحديث المحتوى',
    ouRequired: true,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: { read: false },
    },
    children: [
      {
        name: 'CONTENT_UPDATE_DATA_TYPE',
        arabic: ' أنواع البيانات',
        ouRequired: false,
        tagRequired: true,
        tagAlias: 'data_type',
        tag: null,
        options: {
          type: 'CHECKBOX',
          options: { read: false },
        },
      },
      {
        name: 'CONTENT_APPROVE',
        arabic: 'الموافقة على المحتوى',
        ouRequired: false,
        // tagRequired: true,
        // tagAlias: 'data_type',
        // tag: null,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
    ],
  },
  {
    name: 'CONTENT',
    arabic: 'المحتوى',
    ouRequired: true,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
  },

  // {
  //   name: 'TRAINING_EDIT_ADMIN',
  //   arabic: 'TRAINING_EDIT_ADMIN',
  //   ouRequired: false,
  //   ou: null,
  //   options: {
  //     type: 'RADIO',
  //     options: {
  //       allow: false,
  //     },
  //   },
  // },

  {
    name: 'ASSIGN_USERS',
    arabic: "تحديد مستخدمين",
    ouRequired: true,
    ou: null,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'GRAPHS',
    arabic: 'الرسم البياني',
    ouRequired: false,
    ou: null,
    tagRequired: true,
    tagAlias: 'graph_tags',
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'TRAINER',
    arabic: 'المدربين',
    ouRequired: false,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        delete: false,
      },
    },
  },

  {
    name: 'TRAINING_TYPE',
    arabic: 'إعدادات التدریب',
    ouRequired: false,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
  },

  {
    name: 'COMPANY',
    arabic: 'شركة خارجية',
    ouRequired: false,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
  },

  {
    //DONE
    name: 'CONTINUOUS_TRAINING',
    arabic: 'التدريب المستدام',
    ouRequired: false,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
    children: [
      {
        name: 'CONTINUOUS_TRAINING_REQUEST',
        arabic: 'طلبات التدريب المستدام',
        ouRequired: false,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
      {
        name: 'CONTINUOUS_TRAINING_PUBLISH',
        arabic: 'نشر التدريب المستدام',
        ouRequired: false,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
      {
        name: 'CONTINUOUS_TRAINING_APPROVE',
        arabic: 'اعتماد التدريب المستدام',
        ouRequired: false,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
      {
        name: 'CONTINUOUS_TRAINING_ACTIVE',
        arabic: 'تفعيل التدريب المستدام',
        ouRequired: false,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
      {
        name: 'CONTINUOUS_TRAINING_DASHBOARD',
        arabic: 'لوحة تحكم التدريب المستدام',
        ouRequired: false,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
    ],
  },
  {
    //DONE
    name: 'NEW_BRANCH_TRAINING',
    arabic: 'تدريب فرع جديد',
    ouRequired: false,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
    children: [
      {
        name: 'NEW_BRANCH_TRAINING_PUBLISH',
        arabic: 'نشر تدريب فرع جديد',
        ouRequired: false,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
      {
        name: 'NEW_BRANCH_TRAINING_DASHBOARD',
        arabic: 'لوحة تحكم تدريب فرع جديد',
        ouRequired: false,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
    ],

  },
  {
    //DONE
    name: 'SKILL_TRAINING',
    arabic: 'التدريب المهاري',
    ouRequired: false,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
    children: [
      {
        name: 'SKILL_TRAINING_PUBLISH',
        arabic: 'نشر التدريب المهاري',
        ouRequired: false,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
      {
        name: 'SKILL_TRAINING_ADD_USER',
        arabic: 'إضافة مستخدم للتدريب المهاري',
        ouRequired: false,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
      {
        name: 'SKILL_TRAINING_DASHBOARD',
        arabic: 'لوحة تحكم التدريب المهاري',
        ouRequired: false,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
    ],
  },

  {
    //DONE
    name: 'SURVEY',
    arabic: 'استبيان',
    ouRequired: false,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
    children: [
      {
        name: 'SURVEY_TYPE',
        arabic: 'نوع الاستبيان',
        ouRequired: false,
        tagRequired: true,
        tagAlias: 'survey_type_tag',
        tag: null,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
      {
        name: 'SURVEY_TAGS',
        arabic: 'علامات الاستبيان',
        ouRequired: false,
        tag: null,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
    ],
  },

  {
    //DONE
    name: 'ASSESSMENT',
    arabic: 'الاختبار',
    ouRequired: false,
    ou: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
    children: [
      {
        name: 'ASSESSMENT_TAGS',
        arabic: 'علامات الاختبار',
        ouRequired: false,
        tagRequired: true,
        tagAlias: 'assessment_tag',
        tag: null,
        options: {
          type: 'CHECKBOX',
          options: {
            read: false,
            write: false,
            update: false,
            delete: false,
          },
        },
      },
      {
        name: 'GENERAL_QB',
        arabic: 'بنك الأسئلة العام',
        ouRequired: false,
        tagRequired: false,
        tag: null,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
      {
        name: 'GENERAL_TOPIC',
        arabic: 'إدارة المواضيع',
        ouRequired: false,
        tagRequired: false,
        tag: null,
        options: {
          type: 'RADIO',
          options: {
            allow: false,
          },
        },
      },
    ],
  },

  {
    name: 'TRAINING_PROGRAM',
    arabic: 'البرامج التدريبية',
    ouRequired: true,
    tagRequired: true,
    tagAlias: 'training_type',
    tag: null,
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
      },
    },
  },

  {
    name: 'IMPACT_SETTINGS',
    arabic: 'إعدادات قياس الأثر',
    ouRequired: false,
    tagRequired: false,
    tagAlias: null,
    tag: null,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'PROGRAM_PUBLISH',
    arabic: 'نشر البرامج التدريبية',
    ouRequired: true,
    tagRequired: true,
    tagAlias: 'training_type',
    tag: null,
    options: {
      type: 'RADIO',
      options: {
        allow: false,
      },
    },
  },

  {
    name: 'PERIODIC_REPORTS',
    arabic: 'التقارير الدورية',
    options: {
      type: 'CHECKBOX',
      options: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
    },
  },
  // {
  //   //DONE
  //   name: 'TRAINING_REQUEST',
  //   arabic: 'Training Request',
  //   ouRequired: false,
  //   ou: null,
  //   options: {
  //     type: 'CHECKBOX',
  //     options: {
  //       read: false,
  //       write: false,
  //       update: false,
  //       delete: false,
  //     },
  //   },
  // },

  // {
  //   //DONE
  //   name: 'COURSE',
  //   arabic: 'Course',
  //   ouRequired: false,
  //   ou: null,
  //   options: {
  //     type: 'CHECKBOX',
  //     options: {
  //       read: false,
  //       write: false,
  //       update: false,
  //       delete: false,
  //     },
  //   },
  // },
];
